<template>
  <div class="container">
    <div class="form-wrapper">
      <form
        @submit.prevent="saveBuild"
        class="form"
      >
        <div class="form-content">
          <label
            class="label"
            for="name-input"
            :class="inputName.length ? isNameUnique(inputName.trim()) ? 'valid-label' : 'overwrite-label' : 'required-label'"
          >
            {{ inputName.length ? isNameUnique(inputName) ? 'Name' : 'Name found. Will update save.' : 'Name (Required)' }}
          </label>
          <input
            class="input"
            autocomplete="off"
            id="name-input"
            spellcheck="false"
            type="text"
            placeholder="Character name..."
            v-model="inputName"
            required
            @focusout="loadExistingSave"
          >
          <label
            class="label"
            for="class-input"
          >Class (Optional)</label>
          <input
            class="input"
            autocomplete="off"
            id="class-input"
            spellcheck="false"
            type="text"
            placeholder="Class (e.g. Burster, Sniper, Melee, etc.)"
            v-model="inputClass"
          >
          <label
            class="label"
            for="role-input"
          >Role (Optional)</label>
          <input
            class="input"
            autocomplete="off"
            id="role-input"
            spellcheck="false"
            type="text"
            placeholder="Role (e.g. Main, PvP, Support, RP, etc.)"
            v-model="inputRole"
          >
          <label
            class="label"
            for="class-input"
          >Author (Optional)</label>
          <input
            class="input"
            autocomplete="off"
            id="author-input"
            spellcheck="false"
            type="text"
            placeholder="Author..."
            v-model="inputAuthor"
          >
          <label
            class="label"
            for="notes-input"
          >Notes (Optional)</label>
          <textarea
            class="textarea"
            id="notes-input"
            name="notes"
            rows="5"
            spellcheck="false"
            placeholder="Add notes here..."
            v-model="inputNotes"
          />
          <GenericButton
            :is-disabled="disableSubmit || !inputName.trim().length"
            full-width
            :text="inputName.trim().length ? isNameUnique(inputName.trim()) ? 'CREATE NEW SAVE' : 'UPDATE EXISTING SAVE' : 'NAME IS REQUIRED'"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex"
import { computed, defineComponent, ref } from "vue"
import GenericButton from "../GenericButton.vue"
export default defineComponent({
 name: "CharacterTable",
 components: { GenericButton },
 setup() {
    const store = useStore()
    const inputName = ref('')
    const inputClass = ref('')
    const inputRole = ref('')
    const inputAuthor = ref('')
    const inputNotes = ref('')
    const newSave = ref(true)

    const libraryKeys = Object.keys(store.state.library) || []
    const isNameUnique = (name) => {
      return name.length && !libraryKeys.includes(name.trim());
    }
    const disableSubmit = computed(() => {
      return !(
        store.state.build.info.taggedSkills === 3 &&
        store.state.build.SPECIAL.PL.value === 0
      );
    });

    const saveBuild = () => {
      const save = {
        name: inputName.value.trim(),
        class: inputClass.value.trim(),
        role: inputRole.value.trim(),
        author: inputAuthor.value.trim(),
        notes: inputNotes.value.trim()
      }
      store.dispatch('saveCharacter', save)
    }

    const loadExistingSave = ()  => {
      const unique = isNameUnique(inputName.value.trim())
      if (!unique) {
        newSave.value = false
        const save = store.state.library[inputName.value.trim()]
        if (save) {
            inputClass.value = save.class
            inputRole.value = save.role
            inputAuthor.value = save.author
            inputNotes.value = save.notes
        }
      } else {
        newSave.value = true
      }
    }
    
    return {
      state: store.state,
      inputName,
      inputClass,
      inputRole,
      inputAuthor,
      inputNotes,
      libraryKeys,
      isNameUnique,
      saveBuild,
      loadExistingSave,
      disableSubmit
   }
 },
})
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.form {
  height: 100%;
}
.form-content {
  display: flex;
  flex-direction: column;
  height: 95%;
  gap: 4px;
  justify-content: space-between;
  align-items: center;
}

.form-content > button {
  flex-grow: 1;
  margin-top: 10px;
}
.form-wrapper {
  width: 90%;
  height: 100%;
  text-align: left;
  position: relative;
}
.required-label {
  color:#dcb6b6;
}
.valid-label {
  color: var(--text-yellow);
}
.overwrite-label {
  color: #e3af4f;
}
.textarea, .input {
  width: 96%;
  border-radius: 3px;
  font-weight: 600;
  text-shadow: 1px 1px 1px black;
  text-align: left;
  background-color: rgba(215, 196, 155, 0.222);
  padding: 0px 5px 0px 5px;
  color: inherit;
  border: 1px solid #f6d84290;
  outline: none;

}
.textarea {
  resize: none;
  height: 200px;
  font-size: 14px;
  padding-top: 3px;
}
.input {
  height: 30px;
  line-height: 20px;
  margin-bottom: 10px;
}
.input::placeholder {
  color: rgba(255, 255, 255, 0.531);
}
.textarea::placeholder {
  color: rgba(255, 255, 255, 0.531);
}
.input:focus, .textarea:focus {
  border: 1px solid #99f185;
}
.label {
  width: 100%;
  text-align: left;
  line-height: 20px;
  color: var(--text-yellow);
  text-shadow: 1px 1px 1px black;
}
</style>